import { Controller } from "@hotwired/stimulus"
import { createModalBehavior, MODAL_OPEN_BODY_CLASS } from "../utils/modal_behavior"

export default class extends Controller {
  static targets = ["frame", "closer"]

  connect() {
    this.behavior = createModalBehavior({
      getBackdrop: () => this.modalBackdrop,
      getModal: () => this.modalBox,
    })

    if (!this.isOpen() && document.body.style.position === "fixed") {
      this.releaseScrollLock()
    }

    this.disconnectSwipeClose = this.behavior.listenForSwipeClose(() => this.close())
  }

  disconnect() {
    this.disconnectSwipeClose()
  }

  handleFrameLoad() {
    if (this.isOpen()) return
    this.open()
  }

  // It is used to close modal from backend via turbo_stream
  // Method that is used in rails controller
  //  turbo_stream.append(:modal, "<div data-modal-target='closer'></div>".html_safe)
  closerTargetConnected() {
    this.close()
  }

  isOpen() {
    return this.behavior.isOpen()
  }

  get modalBackdrop() {
    return document.getElementById("modal-backdrop")
  }

  get modalBox() {
    return document.getElementById("modal-box")
  }

  open() {
    this.behavior.open()
  }

  close() {
    this.behavior.close()
  }

  // Used when the modal is closed as a side effect of a Turbo Frame navigation
  // (e.g. applying/clearing filters): the frame swap tears down the modal DOM
  // itself, so we only need to undo the one thing that survives it — the
  // modal-is-open class on <body> that hides the mobile navigation buttons.
  showMobileNavigationButtons() {
    setTimeout(() => {
      document.body.classList.remove(MODAL_OPEN_BODY_CLASS)
    }, 150)
  }

  releaseScrollLock() {
    this.behavior.releaseScrollLock()
  }
}
